import React from 'react'
import { Col, FormGroup, Label, Row, Input } from 'reactstrap';

import imgbg from '../img/bt-ng.png';
import LiquidityForm from './LiquidityForm';

function TokenOffer() {
    return (
        <div className="header-offset">
            <div className='bg-one'>
                <h3 className='text-center text-light pt-5'>TOKEN OFFER</h3>
            </div>

            <div>
                <div className='container pt-5 pb-5 new-s'>
                    <div className='text-center pb-5'>
                    <img src={imgbg} alt="" />
                    </div>
                    <LiquidityForm />

                </div>
            </div>
        </div>
    )
}


export default TokenOffer